module.exports = __webpack_public_path__ + "img/30.334c0bd4.jpg";